import { Component, Input } from '@angular/core';
import { IconBadgeBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-icon-badge',
  templateUrl: './mr-icon-badge.component.html',
  styleUrls: ['./mr-icon-badge.component.scss'],
})
export class MrIconBadgeComponent extends MessageBlockBaseDirective {
  @Input() block!: IconBadgeBlock;
}
